import { DASHBOARD, REPORT_DATA, ROOT_PATH } from '../routes/routes'

export const matchReportDataPath = (pathname: string): boolean =>
  pathname.includes(REPORT_DATA)

export const matchRootPath = (pathname: string): boolean =>
  pathname === ROOT_PATH || pathname === DASHBOARD
